import CheckboxFacets from '../components/filters/checkbox-facets'
import OptionFacets from '../components/filters/option-facets'
import RangeFacets from '../components/filters/range-facets'
import { titleCase } from '~/utils/string'

import {
  dealTypeFormat,
  speedRangeFormat,
  monthlyCostFormat,
  broadbandTypesFormat,
  inclusiveCallTypesFormat,
  specialOffersFormat
} from './formatting'
import { dealTypeSort, alphaSortList, inclusiveCallSort, alphaNameSortList, broadbandTypesSort } from './sorting'
import { broadbandTypesTooltipTexts } from './tooltip-texts'

const filterConfig = (opts = {}) => {
  const showSpecialOffers = opts.specialOffers ?? true

  return [
    ...(showSpecialOffers
      ? [
          {
            objKey: 'specialOffers',
            title: 'Special offers',
            name: 'special_offers',
            FacetType: CheckboxFacets,
            formatLabelFn: specialOffersFormat,
            sortingFn: alphaSortList,
            maxVisibleFacets: 6
          }
        ]
      : []),
    {
      objKey: 'dealType',
      title: 'Package',
      name: 'packages',
      FacetType: CheckboxFacets,
      formatLabelFn: dealTypeFormat,
      sortingFn: dealTypeSort,
      maxVisibleFacets: 6
    },
    {
      objKey: 'speed',
      title: 'Speed',
      name: 'download_speeds',
      ranges: [
        { rangeFrom: 0, rangeTo: 30000 },
        { rangeFrom: 30000, rangeTo: 60000 },
        { rangeFrom: 60000, rangeTo: 100000 },
        { rangeFrom: 100000 }
      ],
      formatLabelFn: speedRangeFormat,
      overrideUnit: 'Mbps',
      FacetType: RangeFacets,
      type: 'range',
      maxVisibleFacets: 6
    },
    {
      objKey: 'broadbandTypes',
      title: 'Broadband type',
      name: 'broadband_types',
      FacetType: CheckboxFacets,
      sortingFn: broadbandTypesSort,
      formatLabelFn: opts.broadbandTypesFormat || broadbandTypesFormat,
      tooltipTexts: broadbandTypesTooltipTexts,
      maxVisibleFacets: 6
    },
    {
      objKey: 'providerIds',
      title: 'Provider',
      name: 'providers',
      FacetType: CheckboxFacets,
      sortingFn: alphaNameSortList,
      type: 'dynamic',
      maxVisibleFacets: 7,
      showLogo: true
    },
    {
      objKey: 'channels',
      title: 'Channels',
      name: 'channels',
      FacetType: CheckboxFacets,
      sortingFn: alphaNameSortList,
      intent: 'TV_PURCHASES',
      type: 'dynamic',
      maxVisibleFacets: 7,
      showLogo: true
    },
    {
      objKey: 'contractLength',
      title: 'Contract length',
      name: 'contract_length',
      formatLabelFn: (x) => x,
      FacetType: OptionFacets,
      maxVisibleFacets: 6,
      shouldShowUnit: true
    },
    {
      objKey: 'monthlyCost',
      title: 'Monthly cost',
      name: 'monthly_cost',
      ranges: [{ rangeFrom: 0, rangeTo: 25 }, { rangeFrom: 25, rangeTo: 40 }, { rangeFrom: 40 }],
      formatLabelFn: monthlyCostFormat,
      FacetType: RangeFacets,
      type: 'range',
      maxVisibleFacets: 6,
      subtitle: '(includes line rental)',
      shouldShowUnit: false
    },
    {
      objKey: 'inclusiveCallTypes',
      title: 'Inclusive calls',
      name: 'inclusive_calls',
      sortingFn: inclusiveCallSort,
      FacetType: CheckboxFacets,
      formatLabelFn: inclusiveCallTypesFormat,
      maxVisibleFacets: 6
    },
    {
      objKey: 'downloadLimitTypes',
      title: 'Downloads',
      name: 'downloads',
      FacetType: CheckboxFacets,
      sortingFn: alphaSortList,
      formatLabelFn: (value) => titleCase(value.toLowerCase()),
      maxVisibleFacets: 6
    }
  ]
}

export default filterConfig
